import React from 'react'
import { FormPaymentGateways } from '../components/Form'
import { nameActions } from '../domain/info'
import { breadcrumbCreate } from '../domain/breadcrumb'
import { toolsCreate } from '../domain/tools/create'
import Container from '../../../../components/Container'

const PaymentGatewayCreate = (): JSX.Element => {
  return (
    <Container
      pageTitle={nameActions.create.name}
      breadcrumb={breadcrumbCreate}
      tools={toolsCreate}
    >
      <FormPaymentGateways typeForm="create" />
    </Container>
  )
}
export default PaymentGatewayCreate
